module.exports = __webpack_public_path__ + "static/img/12.da996bc.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/7/1/eng/12.png
// module id = E/ar
// module chunks = 0